'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var INPUT_SIZE_OPTIONS = exports.INPUT_SIZE_OPTIONS = {
  default: '',
  small: 'private-form__control--small'
};

var USE_CLASSES = exports.USE_CLASSES = {
  default: '',
  'on-dark': 'private-form__control--on-dark'
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/input/InputConstants.js
// module id = 93
// module chunks = 0